import URI from "urijs";

export default class Url {
  static updateQueryString ( key, value, replaceState = false ) {
    let newPageUrl = window.location.href;
    const param = {};
    param[key] = value;

    if ( value ) {
      newPageUrl = URI( newPageUrl ).setQuery( param );
    } else {
      newPageUrl = URI( newPageUrl ).removeQuery( key );
    }

    if ( replaceState ) {
      window.history.replaceState( {}, "", newPageUrl );
    } else {
      window.history.pushState( {}, "", newPageUrl );
    }
  }
}
